"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LineChart = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styles = require("@mui/material/styles");
var _recharts = require("recharts");
var _reactI18next = require("react-i18next");
var _Tooltip = require("./Tooltip");
var _Legend = require("./Legend");
var LineChart = function LineChart(_ref) {
  var data = _ref.data;
  var _useTranslation = (0, _reactI18next.useTranslation)(),
    t = _useTranslation.t;
  var theme = (0, _styles.useTheme)();
  var ref = (0, _react.useCallback)(function (node) {
    if (node !== null) {
      node.container.style.background = theme.palette.chartContainerBackground;
      node.container.style.boxShadow = theme.palette.chartContainerShadow;
      // NOTE: Make svg accessible
      node.container.querySelector('svg title').textContent = t('price') + ' ' + t('chart');
      node.container.querySelector('svg title').id = 'chart-title';
      node.container.querySelector('svg desc').id = 'chart-desc';
      node.container.querySelector('svg desc').textContent = t('price') + ' ' + t('chart');
      node.container.querySelector('svg').setAttribute('aria-labelledby', 'chart-title chart-desc');
      node.container.querySelector('svg').setAttribute('role', 'graphics');
    }
  }, []);
  var minRef = (0, _react.useCallback)(function (node) {
    if (!node) {
      return;
    }
    if (node) {
      var elem = document.querySelectorAll('.recharts-area')[1];
      elem.style.filter = "drop-shadow(0px 0px 1px ".concat(theme.palette.error.light, ")");
    }
  }, []);
  var maxRef = (0, _react.useCallback)(function (node) {
    if (node) {
      var elem = document.querySelectorAll('.recharts-area')[2];
      elem.style.filter = "drop-shadow(0px 0px 1px ".concat(theme.palette.success.light, ")");
    }
  }, []);
  var modRef = (0, _react.useCallback)(function (node) {
    if (node) {
      var elem = document.querySelectorAll('.recharts-area')[0];
      elem.style.filter = "drop-shadow(0px 0px 1px ".concat(theme.palette.info.light, ")");
    }
  }, []);
  var arrRef = (0, _react.useCallback)(function (node) {
    if (node) {
      document.querySelector('.recharts-line').style.filter = "drop-shadow(0px 0px 1px ".concat(theme.palette.secondary.light, ")");
    }
  }, []);
  (0, _react.useEffect)(function () {
    if (document.querySelector('.recharts-wrapper')) {
      document.querySelector('.recharts-wrapper').style.background = theme.palette.chartContainerBackground;
    }
  }, [theme]);
  return /*#__PURE__*/_react.default.createElement(_recharts.ResponsiveContainer, null, /*#__PURE__*/_react.default.createElement(_recharts.ComposedChart, {
    ref: ref,
    data: data,
    margin: {
      top: 8,
      bottom: -16,
      right: 8,
      left: 8
    }
  }, /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("linearGradient", {
    id: "maximum-fill",
    x1: "0",
    y1: "0",
    x2: "0",
    y2: "1"
  }, /*#__PURE__*/_react.default.createElement("stop", {
    offset: "10%",
    stopColor: theme.palette.success.main,
    stopOpacity: 0.9
  }), /*#__PURE__*/_react.default.createElement("stop", {
    offset: "95%",
    stopColor: theme.palette.success.dark,
    stopOpacity: 0.2
  })), /*#__PURE__*/_react.default.createElement("linearGradient", {
    id: "maximum-stroke",
    x1: "0",
    y1: "0",
    x2: "0",
    y2: "1"
  }, /*#__PURE__*/_react.default.createElement("stop", {
    offset: "10%",
    stopColor: theme.palette.success.main,
    stopOpacity: 0.9
  }), /*#__PURE__*/_react.default.createElement("stop", {
    offset: "95%",
    stopColor: theme.palette.success.dark,
    stopOpacity: 0.5
  })), /*#__PURE__*/_react.default.createElement("linearGradient", {
    id: "minimum-fill",
    x1: "0",
    y1: "0",
    x2: "0",
    y2: "1"
  }, /*#__PURE__*/_react.default.createElement("stop", {
    offset: "10%",
    stopColor: theme.palette.error.main,
    stopOpacity: 0.9
  }), /*#__PURE__*/_react.default.createElement("stop", {
    offset: "95%",
    stopColor: theme.palette.error.dark,
    stopOpacity: 0.2
  })), /*#__PURE__*/_react.default.createElement("linearGradient", {
    id: "minimum-stroke",
    x1: "0",
    y1: "0",
    x2: "0",
    y2: "1"
  }, /*#__PURE__*/_react.default.createElement("stop", {
    offset: "10%",
    stopColor: theme.palette.error.main,
    stopOpacity: 0.9
  }), /*#__PURE__*/_react.default.createElement("stop", {
    offset: "95%",
    stopColor: theme.palette.error.dark,
    stopOpacity: 0.5
  })), /*#__PURE__*/_react.default.createElement("linearGradient", {
    id: "modal-stroke",
    x1: "0",
    y1: "0",
    x2: "0",
    y2: "1"
  }, /*#__PURE__*/_react.default.createElement("stop", {
    offset: "10%",
    stopColor: theme.palette.info.main,
    stopOpacity: 0.9
  }), /*#__PURE__*/_react.default.createElement("stop", {
    offset: "95%",
    stopColor: theme.palette.info.dark,
    stopOpacity: 0.5
  })), /*#__PURE__*/_react.default.createElement("linearGradient", {
    id: "arrivals-fill",
    x1: "0",
    y1: "0",
    x2: "0",
    y2: "1"
  }, /*#__PURE__*/_react.default.createElement("stop", {
    offset: "10%",
    stopColor: theme.palette.secondary.main,
    stopOpacity: 0.9
  }), /*#__PURE__*/_react.default.createElement("stop", {
    offset: "20%",
    stopColor: theme.palette.secondary.dark,
    stopOpacity: 0.8
  })), /*#__PURE__*/_react.default.createElement("linearGradient", {
    id: "arrivals-stroke",
    x1: "0",
    y1: "0",
    x2: "0",
    y2: "1"
  }, /*#__PURE__*/_react.default.createElement("stop", {
    offset: "10%",
    stopColor: theme.palette.secondary.main,
    stopOpacity: 0.9
  }), /*#__PURE__*/_react.default.createElement("stop", {
    offset: "20%",
    stopColor: theme.palette.secondary.dark,
    stopOpacity: 0.8
  }))), /*#__PURE__*/_react.default.createElement(_recharts.CartesianGrid, {
    strokeDasharray: "2 2 ",
    vertical: false,
    horizontal: false,
    stroke: theme.palette.text.primary
  }), /*#__PURE__*/_react.default.createElement(_recharts.XAxis, {
    axisLine: false,
    tickLine: false,
    scale: "auto",
    domain: [data.at(0).date, data.at(-1).date],
    tick: function tick(props) {
      var x = props.x,
        y = props.y,
        stroke = props.stroke,
        payload = props.payload;
      return /*#__PURE__*/_react.default.createElement("g", {
        transform: "translate(".concat(x, ",").concat(y, ")")
      }, /*#__PURE__*/_react.default.createElement("text", {
        x: 0,
        y: 0,
        dy: 16,
        fill: theme.palette.text.primary
      }, /*#__PURE__*/_react.default.createElement("tspan", {
        textAnchor: "middle",
        x: "0"
      }, t('intlDateShort', {
        val: new Date(payload.value)
      }))));
    },
    dataKey: "date"
  }), /*#__PURE__*/_react.default.createElement(_recharts.YAxis, {
    axisLine: false,
    tickLine: false,
    domain: [0, Math.max.apply(null, data.map(function (item) {
      return item.maximum;
    })) + 500],
    allowDataOverflow: true,
    mirror: true,
    tickCount: 4,
    tick: function tick(props) {
      var x = props.x,
        y = props.y,
        stroke = props.stroke,
        payload = props.payload,
        index = props.index;
      var _x = x + 20,
        _y = y;
      if (index === 0) {
        _y = y - 25;
      }
      return /*#__PURE__*/_react.default.createElement("g", {
        transform: "translate(".concat(_x, ",").concat(_y, ")")
      }, /*#__PURE__*/_react.default.createElement("text", {
        x: 0,
        y: 0,
        dy: 16,
        fill: theme.palette.text.primary,
        style: {
          fontWeight: 'bold'
        }
      }, /*#__PURE__*/_react.default.createElement("tspan", {
        textAnchor: "middle",
        x: "0"
      }, t('intlCurrencyShort', {
        val: payload.value
      }))));
    },
    orientation: "left"
  }), /*#__PURE__*/_react.default.createElement(_recharts.Tooltip, {
    content: /*#__PURE__*/_react.default.createElement(_Tooltip.Tooltip, null)
  }), /*#__PURE__*/_react.default.createElement(_recharts.Legend, {
    content: /*#__PURE__*/_react.default.createElement(_Legend.Legend, null)
  }), /*#__PURE__*/_react.default.createElement(_recharts.Area, {
    ref: modRef,
    dataKey: "modal",
    strokeWidth: 2,
    dot: {
      stroke: theme.palette.info.main,
      strokeWidth: 1,
      fill: theme.palette.info.dark,
      r: 3
    },
    type: "monotone",
    stroke: "url(#modal-stroke)"
  }), /*#__PURE__*/_react.default.createElement(_recharts.Area, {
    ref: minRef,
    type: "monotone",
    dataKey: "minimum",
    strokeWidth: 2,
    stroke: "url(#minimum-stroke)",
    fill: "url(#minimum-fill)",
    dot: {
      stroke: theme.palette.error.main,
      strokeWidth: 1,
      fill: theme.palette.error.dark,
      r: 3
    }
  }), /*#__PURE__*/_react.default.createElement(_recharts.Area, {
    type: "monotone",
    ref: maxRef,
    fill: "url(#maximum-fill)",
    strokeWidth: 2,
    stroke: "url(#maximum-stroke)",
    dataKey: "maximum",
    dot: {
      stroke: theme.palette.success.main,
      strokeWidth: 1,
      fill: theme.palette.success.dark,
      r: 3
    }
  }), /*#__PURE__*/_react.default.createElement(_recharts.ZAxis, {
    type: "number",
    dataKey: "arrivals",
    name: "arrivals",
    unit: "quintal"
  }), /*#__PURE__*/_react.default.createElement(_recharts.Line, {
    ref: arrRef,
    type: "monotone",
    strokeWidth: 2,
    stroke: "url(#arrivals-stroke)",
    strokeDasharray: "3 3",
    dataKey: "arrivals",
    dot: {
      stroke: theme.palette.secondary.dark,
      strokeWidth: 1,
      fill: theme.palette.secondary.dark,
      r: 3
    },
    fill: "url(#arrivals-stroke)"
  })));
};
exports.LineChart = LineChart;